import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/testResult';

/**
 * eラーニングテストのState型
 */
export interface ITestResultState {
	readonly testTitle: string;
	readonly score: number;
	readonly scoreMessage: string;
	readonly passFlg: boolean;
	readonly paperType: number; // 表示モード
	readonly groups: Actions.IGroup[];
	readonly questionGroupDisplay: boolean;
}

/**
 * eラーニングテストのState初期値
 */
const initialState: ITestResultState = {
	groups: [],
	paperType: 0,
	passFlg: false,
	questionGroupDisplay: false,
	score: 0,
	scoreMessage: '',
	testTitle: '',
};

/**
 * eラーニングテスト用reducer
 * @param state State
 * @param action アクション
 */
const testResult = (state: ITestResultState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setTestResultParams)) {
		return {
			...state,
			groups: action.payload.groups,
			paperType: action.payload.paperType,
			passFlg: action.payload.passFlg,
			questionGroupDisplay: action.payload.questionGroupDisplay,
			score: action.payload.score,
			scoreMessage: action.payload.scoreMessage,
			testTitle: action.payload.testTitle,
		};
	}

	if (isType(action, Actions.clearTestResultParams)) {
		return initialState;
	}

	return state;
};

export default testResult;



// WEBPACK FOOTER //
// ./src/reducers/testResult.ts